<!--
 * @Description: 选择教务
 * @Author: xiawenlong
 * @Date: 2021-04-22 10:06:14
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-01-13 10:12:55
-->
<template>
  <el-dialog :close-on-click-modal="false" class="add-reg-record" :visible.sync="dialogVisible">
    <div class="title">报名信息</div>
    <div class="close-icon" @click="dialogVisible = false">
      <i class="el-icon-close"></i>
    </div>
    <div class="content">
      <table-list
        ref="regRecordTable"
        :loading="loading"
        :data="regRecordList"
        :search-form="searchForm(this)"
        :columns="columns(this)"
        :options="{ selection: true, height: 400 }"
        @search="onSearch"
        @selectionChange="handleSelectionChange"
      ></table-list>
      <div class="btns">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
const searchForm = _this => [
  {
    label: '报名商品入口',
    prop: 'productAttributeCategoryId',
    type: 'select',
    children: _this.category.map(item => ({
      value: item.productAttributeCategoryId,
      label: item.name,
    })),
    onChange: e => {
      _this.$refs.regRecordTable.$refs.tableSearchBar.resetSearchInput('skuValue')
      _this.categoryChange(e)
    },
  },
  {
    label: '所选服务',
    prop: 'certId',
    type: 'select',
    children: _this.listReview.map(item => ({
      value: item.certId,
      label: item.certName,
    })),
  },
  {
    label: '姓名进行搜索',
    prop: 'signUserName',
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'signUserName',
    label: '报名人姓名',
  },
  {
    prop: 'userPhone',
    label: '手机账号',
  },
  {
    prop: 'productName',
    label: '报名商品入口',
  },
  {
    prop: 'skuValue',
    label: '所选服务',
  },
]
import TableList from '@/components/TableList'
import { classCertSignQuery, classCertStudentAdd } from '@/api/certificate'
import { productCertCategory, listReviewByCategory } from '@/api/center'
import to from 'await-to'
export default {
  name: 'AddRegRecord',
  components: { TableList },
  props: {
    classCertId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      searchForm,
      columns,
      dialogVisible: false,
      loading: false,
      regRecordList: [],
      category: [],
      listReview: [],
      select: [],
      queryParams: {},
    }
  },
  methods: {
    show(select = []) {
      this.dialogVisible = true
      this.getProductCertCategory()
      this.getPrincipalList()
      this.$nextTick(() => {
        this.$refs.regRecordTable.$refs.tableList.clearSelection()
        if (select.length) {
          select.forEach(row => {
            this.$refs.regRecordTable.$refs.tableList.toggleRowSelection(row)
          })
        }
      })
    },
    async getProductCertCategory() {
      const [res, err] = await to(productCertCategory({}))
      if (err) return this.$message.warning(err.msg)
      this.category = res.data
    },
    categoryChange(e) {
      this.getListReviewByCategory(e)
    },
    async getListReviewByCategory(productAttributeCategoryId) {
      const [res, err] = await to(listReviewByCategory({ productAttributeCategoryId }))
      if (err) return this.$message.warning(err.msg)
      this.listReview = res.data
    },
    async getPrincipalList() {
      if (this.loading) return
      this.loading = true
      const [res, err] = await to(
        classCertSignQuery({ ...this.queryParams, classCertId: this.classCertId }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.regRecordList = res.data
    },
    async submit() {
      const [, err] = await to(
        classCertStudentAdd(this.select.map(item => ({ ...item, classCertId: this.classCertId }))),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
      this.$emit('success')
      this.dialogVisible = false
    },
    // 查询按钮
    onSearch(queryParams) {
      this.queryParams = queryParams
      this.getPrincipalList()
    },
    // 多选
    handleSelectionChange(val) {
      this.select = val
    },
  },
}
</script>
<style lang="scss" scoped>
.add-reg-record {
  ::v-deep.el-dialog {
    position: relative;
    width: 1000px;
    background: #ffffff;
    border-radius: 0;
    color: #4d4e5d;
    .close-icon {
      z-index: 99;
      cursor: pointer;
      position: absolute;
      right: 24px;
      top: 14px;
      font-size: 25px;
      font-weight: bold;
      color: #8c8c8c;
    }
    .el-dialog__header {
      display: none;
    }
    .el-tabs__header {
      margin-bottom: 26px;
      padding-top: 23px;
    }
    .el-dialog__body {
      padding: 0;
    }
    .title {
      height: 62px;
      line-height: 62px;
      border-bottom: 1px solid #c9c9c9;
      padding-left: 30px;
      font-size: 18px;
    }
    .content {
      padding: 30px 10px;
      > .btns {
        text-align: right;
        padding-top: 30px;
      }
    }
    .el-form-item {
      .el-input,
      .el-select,
      .el-date,
      .el-date-editor {
        width: 200px !important;
      }
    }
  }
}
</style>
